import { useState, useEffect } from "react";
import Footer from "../components/Footer";
import Sitemap from "../components/Sitemap";
import Navbar from "../components/Navbar";
import axios from "axios";
import CountryStore from "../store/CountryStore";

function SitemapPage() {
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSiteMap, setShowSiteMap] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [selectedLetter, setSelectedLetter] = useState('');
  const setGlobalCountry = CountryStore((state) => state.setCountry);
  

  useEffect(() => {
    const fetchSlugs = async () => {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("cat_slug", "panel");
        const response = await axios.post(
          "/api/site_map.php",
          formData
        );

        const uniqueCountries = [
          ...new Set(response.data
            .map((item) => item.country)
            .filter((country) => country !== '')
          ),
        ].sort((a, b) => a.localeCompare(b));
        
        setCountryData(uniqueCountries);        

        const uniqueSlugs = [
          ...new Set(response.data.map((item) => item.slug)),
        ];

        const uniqueData = uniqueSlugs.map((slug) => {
          return response.data.find((item) => item.slug === slug);
        });

        setFilteredData(uniqueData);
      } catch (e) {
        console.error("Error fetching initial slugs:", e);
        setFilteredData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSlugs();
  }, []);

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <Navbar />
      <div className="container mx-auto px-4 sm:px-6 md:px-6 lg:px-8 xl:px-16 2xl:px-24">
      <Sitemap />
      </div>
      <Footer />
    </div>
  );
}

export default SitemapPage;